import { render, staticRenderFns } from "./ClaimAssess.vue?vue&type=template&id=6a46a8ee&scoped=true"
import script from "./ClaimAssess.vue?vue&type=script&lang=js"
export * from "./ClaimAssess.vue?vue&type=script&lang=js"
import style0 from "./ClaimAssess.vue?vue&type=style&index=0&id=6a46a8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a46a8ee",
  null
  
)

export default component.exports